module.exports = "<div ng-if=restrictUi.asInternalFeature()> What is your current setup in regards to [reimbursements]? ... i need to report expenses done with my personal credit card ... monthly ... quarterly ... annually ... at various times throughout the year to do this is x important... today I do this by .... and I am y satisfied with my current/previous solution... </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/action-list-items/contents/current-setup-reimbursements.html
// module id = 1715
// module chunks = 86